import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, connect } from "react-redux";
import { Field } from "redux-form";

import { RequiredMark, CustomDropdownByValue } from "components";
import { uiActions } from "store";
import { requiredNotFalsy } from "validators/validation";

import styles from "./signApplication.module.scss";

const SignApplicationFields = ({
	applicationId,
	submitting,
	pdfTemplates,
	loading,
}) => {
	const dispatch = useDispatch();

	useEffect(() => {
		if (submitting) dispatch(uiActions.showSpinnerOverlay());
		return () => {
			dispatch(uiActions.hideSpinnerOverlay());
		};
	}, [submitting, dispatch]);

	const handleChange = _e => {
		_e.target.blur();
	};

	return (
		<Row>
			<Col md={12} className="mt-3">
				<div className={styles.signDropdown}>
					<span style={{ width: "200px" }}>
						Choose the Agreement
						<RequiredMark />
					</span>
					<Field
						component={CustomDropdownByValue}
						tabIndex="6"
						validate={[requiredNotFalsy]}
						name="selectedPDFTemplateType"
						smSelect={12}
						items={pdfTemplates}
						labelName="displayName"
						onChange={handleChange}
						loading={loading}
					/>
					<span className={styles.deescFoot}>
						which we send to all signatories
					</span>
				</div>
			</Col>
		</Row>
	);
};

const mapStateToProps = state => ({
	pdfTemplates: state.dropdownValues.pdfTemplates,
	loading: state.dropdownValues.loading.pdfTemplates,
});

export default connect(mapStateToProps)(SignApplicationFields);
